import { render, staticRenderFns } from "./PlantAppointmentsCard.vue?vue&type=template&id=bded7f46&"
import script from "./PlantAppointmentsCard.vue?vue&type=script&lang=ts&"
export * from "./PlantAppointmentsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports